import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getApiUrl, apiList } from 'src/app/core/Constants/apiList';

@Injectable({
  providedIn: 'root'
})
export class ClientRuleService {

constructor(
  private http: HttpClient,
) { }

public getSystemAllRules(filterPayload:any,id:number) {
  let endpoint = getApiUrl(apiList.clientRule.getRuleListClient,filterPayload,{ id:id });
  return this.http.get<any>(endpoint)
}

public getSystemRuleConfigDetails(versionId:any) {
  // let endpoint = getApiUrl(apiList.clientRule.getRuleListClientDetail)+`/${versionId}`;
  let endpoint = getApiUrl(apiList.rules.getRuleConfigDetailClient)+`/${versionId}`;
  return this.http.get<any>(endpoint)
}
public saveSystemRuleConfig(payLoad:any) {
  // let endpoint = getApiUrl(apiList.clientRule.postRuleList);
  let endpoint = getApiUrl(apiList.rules.saveConfigClient);
  return this.http.post<any>(endpoint,payLoad)
}
public editSystemRuleConfig(id:any,payload:any) {
  // let endpoint = getApiUrl(apiList.clientRule.clientEditRule)+`/${id}`;
  let endpoint = getApiUrl(apiList.rules.editRule)+`/${id}`;
  return this.http.patch<any>(endpoint,payload);
}
}
